<template>
  <el-main>
    <bread-crumb class="perfil-bread-crumb" classe="conta" titulo="Minha conta" ></bread-crumb>
    <div id="MinhaConta">
      <internal-loading v-if="internalLoading"></internal-loading>
    </div>
  </el-main>
</template>
<script>
import breadCrumb from '@/components/shared/bread-crumb/BreadCrumb.vue'
import internalLoading from '../../components/shared/loading/InternalLoading'

import { mapState, mapActions } from 'vuex'
export default {
  name: 'MinhaConta',
  components: {
    breadCrumb,
    internalLoading
  },
  data () {
    return {
      internalLoading: true
    }
  },
  mounted () {
    let embed = window.omnichannelSDK.embed({
      id: 'MinhaConta',
      url: `${process.env.VUE_APP_URL_OMNI_USER_FRONT}`,
      json: {
        authorization: this.token,
        path: '/minha-conta'
      }
    })
    embed.on('LOADING', (response) => {
      this.internalLoading = response.loading
    })
    embed.on('UPDATE_USER', (res) => {
      if (this.usuario.id_omni_usuario === res.id_omni_usuario) {
        this.loadUsuario(this.token)
      }
    })
  },
  computed: {
    ...mapState('login', [
      'token', 'usuario'
    ])
  },
  methods: {
    ...mapActions('login', [
      'loadUsuario'
    ])
  }
}
</script>
<style scoped>
  .perfil-bread-crumb {
    margin-top: 20px;
  }

  container{
    padding: 0;
  }

</style>
